import { get } from "axios"

const getCatalogoSap = (busqueda, pagina, filtro) => {
    const token = localStorage.getItem('token');
    return (
        get(`${process.env.REACT_APP_URL_API}catalogosap?bus=${busqueda}&pag=${pagina}&fil=${filtro}`, {
            headers: {
                'Authorization': `Bearer ${token}`  // Incluye el token JWT en el encabezado
            }
        })
            .then(response => {
                const { data } = response
                return data
            })
            .catch(error => {
                return { error: 401, message: 'Sesión expirada. Por favor, inicia sesión nuevamente.' };
            })
    )
}
export default getCatalogoSap